import React from "react"
import PropTypes from "prop-types"
import styles from "./Cards.module.css"
import Card from "./Card"

const Cards = ({ classNames = [], cards, iconColor }) => (
  <section className={`${styles.cards} ${classNames ? classNames.map(className => styles[className]).join(" ") : ""}`}>
    {
      (cards && cards.length > 0) &&
      cards.map((card, cardIndex) => <Card {...card} iconColor={iconColor} key={`card${card.header}${cardIndex}`}/>)
    }
  </section>
)

Cards.propTypes = {
  classNames: PropTypes.array,
  cards: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string,
    icon: PropTypes.string,
    content: PropTypes.any,
    link: PropTypes.string,
  })),
  iconColor: PropTypes.string,
}

export default Cards